module.exports = "<div>\n    <section head></section>\n    <lateralmap socket=\"page.socket\" main=\"main\" settings=\"page.settings\" save-node-info=\"page.saveNodeInfo\" edit-associated-groups=\"page.editAssociatedGroups\" create-edit-group=\"page.createEditGroup\" delete-group=\"page.deleteGroup\" get-groups=\"page.getGroups\" set-groups=\"page.setGroups\"></lateralmap>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/general_network/lateral_map.html
 ** module id = 617
 ** module chunks = 0
 **/